import {useState} from 'react';

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import MenuPopover from '../MenuPopover.js'

import { binary_search } from '../util.ts'

export default function PlayerSelect(props) {
  const [playerId, setPlayerId] = useState('');
  const [playerIdError, setPlayerIdError] = useState('')

  const [playerNickname, setPlayerNickname] = useState('');
  const [playerNicknameError, setPlayerNicknameError] = useState('')

  const handleChangeId = (event) => {
    const newValue = event.target.value;

    setPlayerId(newValue);

    if(newValue.length===0) {
      setPlayerIdError('')
      props.valueChangedId(newValue);
      return;
    }

    // Check if it is a real value
    const player_idx = binary_search(props.jsonPlayers.player_id, newValue);
    if(props.jsonPlayers.player_id[player_idx]!==newValue) {
      setPlayerIdError("Player id not found, will be ignored!");
      setPlayerNickname('');
      setPlayerNicknameError('');
      return;
    }
    setPlayerIdError(null)
    props.valueChangedId(newValue);
  }

  const handleChangeNickname = (event) => {
    const newValue = event.target.value;

    setPlayerNickname(newValue);
    if(newValue.length===0) {
      setPlayerNicknameError('')
      props.valueChangedId(newValue);
      return;
    }

    const player_idx = props.jsonPlayers.nickname.findIndex((x)=>x===newValue);
    if(player_idx===-1) {
      setPlayerNicknameError("Player nickname not found, will be ignored!");
      setPlayerId('');
      setPlayerIdError('');
      return;
    }
    setPlayerNicknameError('')

    props.valueChangedId(props.jsonPlayers.player_id[player_idx]);
  }

  return (
    <MenuPopover changed={props.changed} title="Player Select">
      <Box sx={{ margin: 4, width: 300 }}>
        <Stack spacing={1} sx={{ width: 300 }}>
          <Typography>
            Check only battles in which the player was present. Use either player nickname or player id.
          </Typography>
          <TextField
            id="outlined-name"
            label="Player nick"
            value={playerNickname}
            onChange={handleChangeNickname}
          />
          <Typography style={{color:"red"}}>{playerNicknameError}</Typography>
          <Typography>
            The player ID can be found by opening the player user page and using
            the number from the address.
          </Typography>
          <TextField
            id="outlined-id"
            label="Player ID"
            value={playerId}
            onChange={handleChangeId}
          />
          <Typography style={{color:"red"}}>{playerIdError}</Typography>
        </Stack>
      </Box>
    </MenuPopover>
  )
}

PlayerSelect.propTypes = {
  jsonPlayers: PropTypes.object,
  changed: PropTypes.bool,
  valueChangedId: PropTypes.func,
};
